'use client'

// 閲覧履歴の表示。クッキーはマウント後に読むので、ページ本体は静的にキャッシュできる。

import { getBrowsingHistoryItems } from '@/lib/browsing_history/server'
import type { itemType } from '@/lib/item/server'
import type { serviceType } from '@/lib/service/server'
import { useEffect, useState } from 'react'
import { SubItemList } from '../parts/default/sp/itemlist/sub/itemlist'
import { MarkDownField } from '../parts/default/sp/markdown/mdField'

const defaultCount = {
  pc: 20,
  sp: 8,
  others: 20,
} as const

const deviceFromUserAgent = () => {
  const userAgent = navigator.userAgent
  if (
    userAgent.includes('iPhone') ||
    userAgent.includes('Android') ||
    userAgent.includes('iPad') ||
    userAgent.includes('Tablet')
  ) {
    return 'sp'
  }
  return 'pc'
}

export const BrowsingHistoryClient = ({
  service,
  device,
  count,
  slider = false,
  title,
  description,
  style,
}: {
  service: serviceType
  device?: string
  count?: number
  slider?: boolean
  title: string
  description?: string
  style?: string
}) => {
  const [items, setItems] = useState<itemType[] | null>(null)
  const [resolvedDevice, setResolvedDevice] = useState(device)

  useEffect(() => {
    const nextDevice = device ?? deviceFromUserAgent()
    setResolvedDevice(nextDevice)
    const actualCount =
      count ??
      (nextDevice == 'pc'
        ? defaultCount.pc
        : nextDevice == 'sp'
          ? defaultCount.sp
          : defaultCount.others)
    let cancelled = false
    getBrowsingHistoryItems({ service: service.service_id, count: actualCount })
      .then((result) => {
        if (!cancelled) setItems(result ?? [])
      })
      .catch(() => {
        if (!cancelled) setItems([])
      })
    return () => {
      cancelled = true
    }
  }, [service.service_id, device, count])

  if (!items || items.length === 0 || !resolvedDevice) {
    return null
  }

  if (resolvedDevice == 'pc') {
    return (
      <div className="w-full">
        <div className="max-w-screen-lg mx-auto pt-8 pb-8 space-y-2">
          <h2 className="text-xl font-bold">{title}</h2>
          <SubItemList items={items} service={service} slider={slider} />
        </div>
      </div>
    )
  }
  if (resolvedDevice == 'sp') {
    return (
      <div
        className={`${style ? style : ''} item-list bg-[#f5f5f5] sm:bg-white py-2`}
      >
        <div className="mt-2 w-[94%] m-auto sm:max-w-screen-lg">
          <h2 className="item-list-title font-semibold text-base mb-3 text-[#4f5256]">
            {title}
          </h2>
          {description && description != '' && (
            <div className="item-list-description text-sm text-gray-600 mb-4">
              <MarkDownField text={description} />
            </div>
          )}
          <SubItemList items={items} service={service} slider={slider} />
        </div>
      </div>
    )
  }
  return null
}
